<template>
  <div id="popup-wrapper" @click="clickOutsidePopup">
    <div class="popup-content">
      <h3 v-if="!emailSent" class="blue-text">Please tell us your details and we will be in touch with you:</h3>
      <h3 v-if="emailSent" class="blue-text">We got your message.</h3>
      <form>
        <div v-if="!emailSent" class="form-group">
          <label for="name">Name</label><br>
          <input type="text" v-model="contact.name" name="name" id="name">
        </div>
        <div v-if="!emailSent" class="form-group">
          <label for="company">Company *</label><br>
          <input type="text" v-model="contact.company" name="company" id="company">
          <div v-if="errors.company" class="error">Enter Company</div>
        </div>
        <div v-if="!emailSent" class="form-group">
          <label for="email">Email *</label><br>
          <input type="email" v-model="contact.email" name="email" id="email">
          <div v-if="errors.email" class="error">Enter Email</div>
          <div v-if="errors.invalidEmail" class="error">Invalid email address</div>
        </div>
        <div v-if="!emailSent" class="form-group">
          <label for="phone">Telephone</label><br>
          <input type="tel" v-model="contact.phone" name="phone" id="phone">
          <div v-if="errors.phone" class="error">Invalid telephone number</div>
        </div>
        <div v-if="!emailSent" class="form-group">
          <label for="message">Message</label><br>
          <input type="text" v-model="contact.message" name="message" id="message">
        </div>
        <div v-if="emailSent" class="blue-text">
          <h3>Thank you for contacting us!</h3>
        </div>
        <div v-if="!emailSent" class="btn-wrapper">
          <button type="submit" class="send-button" @click.prevent="sendMessage">Send</button>
        </div>
      </form>
      <p class="popup-bottom">Feel free to get in touch with us on <br />+44 (0)20 808 80034</p>
      <div v-if="connectionError" class="error-message">
        <h3>Something is wrong. Please check your internet connection and try again.</h3>
      </div>
    </div>
  </div>
</template>

<script>
  import { post } from '../apiHttp'

  export default {
    name: 'Popup',
    data () {
      return {
        emailSent: false,
        contact: {
          name: '',
          company: '',
          email: '',
          phone: '',
          message: ''
        },
        errors: {},
        valid: false,
        connectionError: false
      }
    },
    methods: {
      clickOutsidePopup (e) {
        if (e.target.id === 'popup-wrapper') this.$emit('close')
      },
      validForm () {
        this.errors = {}
        this.valid = false

        if (!this.contact.company) {
          this.valid = this.errors.company = true
        }
        if (this.contact.phone && !this.validPhone(this.contact.phone)) {
          this.valid = this.errors.phone = true
        }
        if (this.contact.email) {
          if (!this.validEmail(this.contact.email)) {
            this.valid = this.errors.invalidEmail = true
          }
        } else {
          this.valid = this.errors.email = true
        }

        return this.valid
      },
      validEmail (email) {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return re.test(email)
      },
      validPhone (phone) {
        let re = /^([+]?\d*)$/
        return re.test(phone)
      },
      resetData () {
        this.contact.name = ''
        this.contact.company = ''
        this.contact.email = ''
        this.contact.phone = ''
        this.contact.message = ''
      },
      sendMessage () {
        console.log(this.validForm())
        if (!this.validForm()) {
          console.log(this.validForm())
          post('/send-email', this.contact)
            .then(() => {
              this.emailSent = true
              this.resetData()
            })
            .catch(() => {
              this.connectionError = true
            })
        }
      }
    }
  }
</script>

<style scoped>
  #popup-wrapper {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 200;
    color: #686b84;
    background-color: rgba(0,0,0,.2);
  }
  .popup-content {
    max-width: 500px;
    padding: 50px;
    background-color: #fff;
    text-align: left;
  }
  .popup-content h3 {
    margin-bottom: 30px;
    text-align: center;
  }
  .popup-content input {
    font-family: 'RubicLight', sans-serif;
    font-size: 19px;
    color: #000;
    width: 100%;
    height: 40px;
    padding: 0 12px;
    border: none;
    background-color: #ececec;
  }
  .popup-content .form-group {
    margin-bottom: 15px;
  }
  .popup-bottom {
    font-family: 'RubicMedium', sans-serif;
    color: #000;
    margin-top: 30px;
    text-align: center;
  }
  .btn-wrapper {
    text-align: center;
  }
  .send-button {
    font-family: 'RubicMedium', sans-serif;
    color: #fff;
    font-size: 18px;
    line-height: 21px;
    padding: 10px 40px;
    background: linear-gradient(90deg, #f03a03 0%, #ee28da 100%);
    border-radius: 50px;
    border: none;
    cursor: pointer;
  }
  .error {
    font-size: 17px;
    color: red;
    padding-top: 5px;
  }
  @media (max-width: 479px) {
    .popup-content {
      padding: 30px;
    }
  }
  @media (max-height: 600px) {
    .popup-content {
      height: 80vh;
      overflow-y: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Popup.vue